/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
import ItemsListRPContainerDesktop from './ReportPaymentItemListDesktop';
import ItemsListRPContainerMobile from './ReportPaymentItemListMobile';
import {
    getModifiedItemTableData,
    getNewItemObj,
    productIssueErrMsg,
    invalidProductMsg,
    invalidUnidRodItemQtyMsg,
    lotNumberReqdMsg,
    serialNumberReqdMsg,
    getUniqueKey,
    getRPValidateItemsArr,
    getProductsArrFromReportPaymentFlow,
    modifyDraftProductsResponse,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import {
    storeItemTableData,
    setAllAccountOwned,
    validateProductDetails,
    storeUsageDataPresist,
    setReportPaymentFlag,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { ReportUsageContext } from 'src/pages/reportUsage';
import WarningModal from 'src/pages/reportUsage/common/warningModal';
import { SET_ITEMS_DURING_PRICING } from 'src/pages/reportUsage/redux/action/types';
import { generate_UUID, isIpad, getArrayItem } from 'src/utils/util';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { useTranslation } from 'react-i18next';
import { resetBarcodeDetails } from 'src/common/barCodeScannerRedux/actions/actionCreators';
import { displayCheckbox } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export const ItemsListContext = React.createContext({});

const ItemListRPView = ({ ...props }) => {
    const winWidth = window.innerWidth;
    const dispatch = useDispatch();

    const {
        filteredProduct,
        setFilteredProduct,
        selectedProduct,
        addedProduct,
        resetSelectedOrAddedItem,
        setShowHidePricesBtn,
        setToggleHidePricesBtn,
        isFromReportScreen,
        checkboxReportPaymentClickHandler,
        reportPaymentGridData,
        setReportPaymentGridData,
        selectedCheckBox,
        checkBoxSelectedIndex,
        checkNewAddedProduct,
        deletePO,
        deleteItem,
        onImagePreview,
        showBundlefromTableList,
        addedChildProduct,
        selectedChildProduct,
        setAddedChildProduct,
        setSelectedChildProduct,
        setAddedProduct,
    } = props;
    const { usageDetails, reportUsageFormObj, setReportUsageFormObj } =
        useContext(ReportUsageContext);
    const { t } = useTranslation();
    const bundleHeadersArr =
        usageDetails?.bundleHeaders && usageDetails?.bundleHeaders.split(',');
    const { products } = useSelector((state) => ({
        products: state.productsSearchReducer.products,
    }));
    const pricedItems = useSelector(
        (state) => state.reportUsageRootReducer.pricedItems
    );
    const itemsToBePriced = useSelector(
        (state) => state.reportUsageRootReducer.itemsToBePriced
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const reportPaymentFlag = useSelector(
        (state) => state.reportUsageRootReducer.reportPaymentFlag
    );
    const [selectedChildEditItem, setSelectedChildEditItem] = useState(false);
    const [selectedChildIndex, setSelectedChildIndex] = useState();
    const [selectedChildItem, setSelectedChildItem] = useState();
    const [allAccountSelectedModal, setAllAccountSelectedModal] =
        useState(false);
    const [isBundleExpanded, setIsBundleExpanded] = useState(true);
    const myCaseResourceType = useSelector(
        (state) => state.reportUsageRootReducer.myCaseResourceType
    );
    const [loaderOnOrientationChange, setLoaderOnOrientationChange] =
        useState(false);

    const myCaseRefId = useSelector(
        (state) => state.reportUsageRootReducer.myCaseRefId
    );
    // Ref to track previous lotSerial lengths for change detection
    const prevLotSerialLengthsRef = React.useRef({});

    window.onorientationchange = () => {
        if (isIpad()) {
            setLoaderOnOrientationChange(true);
            setTimeout(() => setLoaderOnOrientationChange(false), 1000);
        }
    };

    // Sync lotSerial from filteredProduct to reportPaymentGridData
    useEffectWithErrorLogging(() => {
        if (filteredProduct?.length > 0 && reportPaymentGridData?.length > 0) {
            let hasChanges = false;
            const updatedGridData = reportPaymentGridData.map((gridItem) => {
                // Split read-only rows carry a fixed single lotSerial (one qty-type each);
                // never re-sync/merge them by CFN or they revert to an editable card.
                if (gridItem.isSplitLotSerialItem) {
                    return gridItem;
                }
                // Match by unqId first for duplicate items, fallback to cfn/productCFN
                const matchingItem = filteredProduct.find(
                    (fp) => (gridItem.unqId && fp.unqId === gridItem.unqId) ||
                            (!gridItem.unqId && (fp.cfn === gridItem.cfn || fp.productCFN === gridItem.productCFN))
                );
                
                // Sync lotSerial for bundle children (cfn contains "m200" or is a bundle item)
                if (matchingItem && (gridItem.cfn?.toLowerCase().includes('m200') || gridItem.isBundleItem)) {
                    if (matchingItem.children?.length > 0 && gridItem.bundleItem?.length > 0) {
                        let bundleChildChanged = false;
                        const updatedBundleItem = gridItem.bundleItem.map((bundleChild) => {
                            const matchingChild = matchingItem.children.find(
                                (child) => child.cfn === bundleChild.cfn || child.productCFN === bundleChild.productCFN
                            );
                            if (matchingChild?.lotSerial && matchingChild.lotSerial.length > 0) {
                                const childLotSerialLength = matchingChild.lotSerial.length;
                                const bundleChildLotSerialLength = bundleChild.lotSerial?.length || 0;
                                if (childLotSerialLength !== bundleChildLotSerialLength || 
                                    JSON.stringify(matchingChild.lotSerial) !== JSON.stringify(bundleChild.lotSerial)) {
                                    bundleChildChanged = true;
                                    return {
                                        ...bundleChild,
                                        lotSerial: matchingChild.lotSerial,
                                        quantity: matchingChild.quantity || bundleChild.quantity,
                                    };
                                }
                            }
                            return bundleChild;
                        });
                        if (bundleChildChanged) {
                            hasChanges = true;
                            return {
                                ...gridItem,
                                bundleItem: updatedBundleItem,
                            };
                        }
                    }
                }
                
                if (matchingItem?.lotSerial) {
                    const currentLotSerialLength = matchingItem.lotSerial.length;
                    const gridLotSerialLength = gridItem.lotSerial?.length || 0;
                    const prevLength = prevLotSerialLengthsRef.current[gridItem.cfn || gridItem.productCFN] || 0;
                    
                    // Check if filteredProduct's lotSerial length has changed from what we last synced
                    if (currentLotSerialLength !== gridLotSerialLength && currentLotSerialLength !== prevLength) {
                        hasChanges = true;
                        prevLotSerialLengthsRef.current[gridItem.cfn || gridItem.productCFN] = currentLotSerialLength;
                        return {
                            ...gridItem,
                            lotSerial: matchingItem.lotSerial,
                            lotSerialNumber: getArrayItem(matchingItem.lotSerial)?.Serial || gridItem.lotSerialNumber || ''
                        };
                    }
                }
                return gridItem;
            });
            
            if (hasChanges) {
                setReportPaymentGridData(updatedGridData);
            }
        }
    }, [filteredProduct]);

    useEffectWithErrorLogging(() => {
        if (
            pricedItems &&
            pricedItems.length > 0 &&
            reportPaymentGridData.length > 0
        ) {
            let modifiedData = getModifiedItemTableData(
                reportPaymentGridData,
                pricedItems,
                bundleHeadersArr,
                isFromReportScreen,
                usageDetails.unidSurgeryInfoPage?.deliveredRodItems,
                myCaseResourceType
            );
            if (myCaseResourceType === 'reportPayment') {
                modifiedData = modifiedData.map((item) => {
                    if (!item.payment && item.isAdditionalCartEntry) {
                        return {
                            ...item,
                            poImageErrorMsg: t(
                                'productValidationMessages.poInfoRequired'
                            ),
                            isPoImageError: true,
                        };
                    } else {
                        return item;
                    }
                });
            }
            setReportPaymentGridData(modifiedData);
            setShowHidePricesBtn(true);
            setToggleHidePricesBtn('hideBtn');
            // setRpInitialLoad(true);
        }
    }, [pricedItems]);

    // Create Object for Added Item
    // const [lotFromScanner, setLotFromScanner] = useState(null);

    useEffectWithErrorLogging(() => {
        var newProduct = [...reportPaymentGridData];
        let newObject = {};
        if (addedProduct?.value && Object.keys(addedProduct).length > 0) {
            const existingItem = newProduct.find((item) => {
                return (
                    item.cfn == addedProduct.value &&
                    item?.lotSerialNumber ==
                        addedProduct?.barcodeData?.batchOrSerialNumber
                );
            });
            const existingItemIndex = newProduct.findIndex(
                (item) =>
                    item.cfn == addedProduct.value &&
                    item?.lotSerialNumber ==
                        addedProduct?.barcodeData?.batchOrSerialNumber
            );
            if (
                existingItem &&
                existingItemIndex !== -1 &&
                !addedChildProduct?.isFromBundleItemScanner &&
                !addedProduct?.isFromAddItem
            ) {
                newProduct[existingItemIndex].usedQuantity =
                    (parseInt(newProduct[existingItemIndex].usedQuantity) ||
                        0) + 1;
                setFilteredProduct(newProduct);
                setReportPaymentGridData(newProduct);
            } else {
                const newlyAddedItem = getNewItemObj(
                    addedProduct,
                    {},
                    true,
                    bundleHeadersArr,
                    false,
                    myCaseResourceType
                );
                if (addedProduct.isBundle) {
                    newlyAddedItem.isBundleFromAddItem = true;
                    newlyAddedItem.bundleItem = [];
                    newlyAddedItem.isBundleItem = addedProduct.isBundle;
                    newlyAddedItem.bundleHeaderPosition =
                        newProduct.filter((data) =>
                            bundleHeadersArr?.includes(
                                data.cfn?.toUpperCase()
                            )
                        ).length;
                }
                newlyAddedItem.unqId = `${getUniqueKey()} ${
                    addedProduct.value
                }`;
                newlyAddedItem.productCFN = addedProduct.value;
                newProduct.push(newlyAddedItem);
                // setLotFromScanner(newlyAddedItem?.lotSerial[0]?.Serial);
                setFilteredProduct(newProduct);
                for (let item of newProduct) {
                    newObject = {
                        ...newObject,

                        basePrice: item.basePrice,
                        id: generate_UUID(),
                        unqId: generate_UUID(),
                        description: item.description,
                        extPrice: item.extPrice,
                        isAccountOwned: item.accountOwned,
                        isAdditionalCartEntry: item.isAdditionalCartEntry,
                        isReplenish: item.isReplenish,
                        productCFN: item.cfn,
                        cfn: item.cfn,
                        salesOrg: item.salesOrg,
                        uom: item.uom,
                        unitPrice: item.unitPrice,
                        usedQuantity: item?.bundleItem
                            ? item.usedQuantity
                                ? item.usedQuantity
                                : 1
                            : item.usedQuantity,
                        lotSerialNumber: item?.lotSerial
                            ? getArrayItem(item?.lotSerial)?.Serial
                            : item.lotSerialNumber,
                        lotSerial: item?.lotSerial || [
                            { Serial: '', used: false, id: getUniqueKey() },
                        ],
                        //  usedQtyExtPrice: item.usedQtyExtPrice,
                        usedQtyExtPrice: item.usedQtyExtPrice,
                        isBundleFromAddItem: item?.isBundleFromAddItem,
                        bundleItem: item?.bundleItem,
                        isBundleItem: item?.isBundleItem,
                        bundleHeaderPosition: item?.bundleHeaderPosition,
                        isPriced: false,
                        scannedGTIN: item?.scannedGTIN ? item?.scannedGTIN : '',
                        // otherQtyExtPrice: item.otherQtyExtPrice,
                    };
                }

                const chekgriddata = [
                    ...reportPaymentGridData,
                    {
                        ...newObject,
                        isAdditionalCartEntry: true,
                    },
                ];
                setReportPaymentGridData(chekgriddata);
            }
            dispatch(setAllAccountOwned(false));
            resetSelectedOrAddedItem();
            setAddedProduct({});
        }
    }, [addedProduct]);

    useEffectWithErrorLogging(() => {
        var newProduct = [...reportPaymentGridData];
        let newObject = {};
        if (selectedProduct?.value && Object.keys(selectedProduct).length > 0) {
            const filteredList = products.filter(
                (item) =>
                    item.cfn === selectedProduct.value &&
                    item.salesOrg === selectedProduct.salesOrg
            );
            if (filteredList?.length > 0) {
                const matchedProduct = getArrayItem(filteredList);
                matchedProduct.unqId = `${getUniqueKey()} ${
                    selectedProduct.value
                }`;
                if (selectedProduct.isBundle) {
                    matchedProduct.isBundleFromAddItem = true;
                    matchedProduct.bundleItem = [];
                    matchedProduct.isBundleItem = selectedProduct.isBundle;
                    matchedProduct.bundleHeaderPosition =
                        newProduct.filter((data) =>
                            bundleHeadersArr?.includes(
                                data.cfn?.toUpperCase()
                            )
                        ).length;
                }
                newProduct.push(matchedProduct);
                setReportPaymentGridData(newProduct);
                for (let item of newProduct) {
                    newObject = {
                        ...newObject,
                        basePrice: item.basePrice,
                        description: item.description,
                        extPrice: item.extPrice,
                        isAccountOwned: item.accountOwned,
                        id: generate_UUID(),
                        unqId: generate_UUID(),
                        isAdditionalCartEntry: item.isAdditionalCartEntry,
                        isReplenish: item.isReplenish,
                        productCFN: item.cfn,
                        cfn: item.cfn,
                        salesOrg: item.salesOrg,
                        uom: item.uom,
                        unitPrice: item.unitPrice,
                        usedQuantity: item?.bundleItem
                            ? item.usedQuantity
                                ? item.usedQuantity
                                : 1
                            : item.usedQuantity,
                        lotSerialNumber: item.lotSerialNumber,
                        lotSerial: item?.lotSerial || [
                            { Serial: '', used: false, id: getUniqueKey() },
                        ],
                        //  usedQtyExtPrice: item.usedQtyExtPrice,
                        usedQtyExtPrice: item.usedQtyExtPrice,
                        isBundleFromAddItem: item?.isBundleFromAddItem,
                        bundleItem: item?.bundleItem,
                        isBundleItem: item?.isBundleItem,
                        bundleHeaderPosition: item?.bundleHeaderPosition,
                        isPriced: false,
                        // otherQtyExtPrice: item.otherQtyExtPrice,
                    };
                }

                const chekgriddata = [
                    ...reportPaymentGridData,
                    {
                        ...newObject,
                        isAdditionalCartEntry: true,
                    },
                ];
                // const chekgriddata = newProduct
                //     .filter((item) => {
                //         return item !== undefined;
                //     })
                //     .map((item) => {
                //         return {
                //             ...item,
                //             basePrice: item.basePrice,
                //             description: item.description,
                //             extPrice: item.extPrice,
                //             isAccountOwned: item.accountOwned,
                //             isAdditionalCartEntry: item.isAdditionalCartEntry,
                //             isReplenish: item.isReplenish,
                //             productCFN: item.cfn,
                //             cfn: item.cfn,
                //             salesOrg: item.salesOrg,
                //             uom: item.uom,
                //             unitPrice: item.unitPrice,
                //             usedQuantity: item.usedQuantity,
                //             lotSerialNumber: item.lotSerialNumber,
                //             //  usedQtyExtPrice: item.usedQtyExtPrice,
                //             usedQtyExtPrice: item.usedQtyExtPrice,
                //             // otherQtyExtPrice: item.otherQtyExtPrice,
                //         };
                //     });

                setReportPaymentGridData(chekgriddata);

                dispatch(setAllAccountOwned(false));
            }
            // selectedProduct lives in the parent; clear it so a remount of this view doesn't re-add the item.
            resetSelectedOrAddedItem();
        }
    }, [selectedProduct]);

    useEffectWithErrorLogging(() => {
        if (
            selectedChildProduct?.child &&
            Object.keys(selectedChildProduct).length > 0
        ) {
            var newProduct = filteredProduct;
            let filteredList = [];
            let filteredProductList = [];
            let selectedIndex = selectedChildProduct.parent.index;
            let selectedParentItem = selectedChildProduct.parent.cfn;

            filteredList = newProduct?.filter((item) => {
                return item?.cfn == selectedParentItem
                    ? selectedParentItem
                    : '';
            });

            if (filteredList) {
                if (!newProduct[selectedIndex].children)
                    newProduct[selectedIndex].children = [];
                newProduct[selectedIndex].bundleItem = [];
                newProduct[selectedIndex].isBundleExpanded = true;

                const filteredChildProducts = products.filter(
                    (item) => item?.cfn === selectedChildProduct?.child
                );

                const matchedChildProduct = getArrayItem(filteredChildProducts);

                if (selectedChildProduct.isBundle) {
                    matchedChildProduct.isBundleFromAddItem = true;
                    matchedChildProduct.isBundleItem = true;
                    matchedChildProduct.isInvalidItemMsg = t(
                        'productValidationMessages.bundleCannotBeAddedAsItemMsg'
                    );
                } else if (matchedChildProduct.isSet) {
                    matchedChildProduct.isInvalidItemMsg = t(
                        'equity.common.utils.setsNotAllowed'
                    );
                } else if (matchedChildProduct.salesOrg === 'S030') {
                    matchedChildProduct.isInvalidItemMsg = t(
                        'equity.common.utils.tissueItems'
                    );
                }
                matchedChildProduct.productCFN =
                    matchedChildProduct.cfn;
                matchedChildProduct.isBundleChild = true;
                matchedChildProduct.isAdditionalCartChild = true;
                matchedChildProduct.id = generate_UUID();
                matchedChildProduct.isPriced = false;
                const childLotSerial = [{ used: false, id: getUniqueKey() }];
                newProduct[selectedIndex].noItemInBundleErr = null;
                newProduct[selectedIndex].bundleItem.push({
                    ...matchedChildProduct,
                    quantity: 1,
                    lotSerial: childLotSerial,
                });
                reportPaymentGridData[selectedIndex].noItemInBundleErr = null;
                reportPaymentGridData[selectedIndex].bundleItem.push({
                    ...matchedChildProduct,
                    quantity: 1,
                    lotSerial: childLotSerial,
                });
                setReportPaymentGridData([...reportPaymentGridData]);
            }

            filteredProductList = newProduct.filter((item) => {
                return item !== undefined;
            });
            const newArray = filteredProductList;
            setFilteredProduct(newArray);
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
            setSelectedChildProduct('');
        }
    }, [selectedChildProduct]);

    useEffectWithErrorLogging(() => {
        myCaseResourceType === 'reportPayment' && dispatch(storeItemTableData(reportPaymentGridData));
        // After Next, formObj.products is the SAP payload (already merged + split); use the original list.
        const accountOwnedSource =
            myCaseResourceType === 'reportPayment'
                ? usageDetails?.products
                : reportUsageFormObj.products;
        const accountOwnedItems =
            accountOwnedSource?.length > 0
                ? accountOwnedSource
                      .map((item, index) => {
                          if (item.isAccountOwned || item.accountOwned) {
                              return {
                                  ...item,
                                  recordIndex: index,
                              };
                          } else {
                              return item;
                          }
                      })
                      .filter(
                          (filterItem) =>
                              filterItem.isAccountOwned ||
                              filterItem.accountOwned
                      )
                : [];
        let updatedItem = [...reportPaymentGridData];
        accountOwnedItems.map((ownedItem) => {
            let temp = {
                ...ownedItem,
            };
            delete temp.recordIndex;
            updatedItem.splice(ownedItem.recordIndex, 0, temp);
        });
        const productsArr = getProductsArrFromReportPaymentFlow(updatedItem);
        const draftProducts = modifyDraftProductsResponse(
            productsArr,
            usageDetails.bundleHeaders
                ? usageDetails.bundleHeaders.split(',')
                : [],
            usageDetails.unidSurgeryInfoPage?.deliveredRodItems,
            true
        );
        setFilteredProduct(draftProducts);
        dispatch({
            type: 'SET_LOCAL_USAGE_TABLE_DATA',
            payload: draftProducts,
        });
        // dispatch(
        //     storeUsageDataPresist({
        //         name: 'reportPayment',
        //         value: reportPaymentGridData,
        //     })
        // );
        // let updatedItem = reportPaymentGridData;
        // const productsArr = getProductsArrFromReportPaymentFlow(updatedItem);
        // const draftProducts = modifyDraftProductsResponse(
        //     productsArr,
        //     usageDetails.bundleHeaders
        //         ? usageDetails.bundleHeaders.split(',')
        //         : [],
        //     usageDetails.unidSurgeryInfoPage?.deliveredRodItems,
        //     true
        // );
        // setFilteredProduct(draftProducts);
        // dispatch({
        //     type: 'SET_LOCAL_USAGE_TABLE_DATA',
        //     payload: draftProducts,
        // });
    }, [reportPaymentGridData]);

    const onAccountOwnedSeleted = (item, index) => {
        let newAry = [...reportPaymentGridData];
        let isAllSelected = true;
        newAry[index] = { ...item, accountOwned: !item.accountOwned };
        if (newAry.length >= 1) {
            newAry.map((item) => {
                if (!item.accountOwned) {
                    isAllSelected = false;
                }
            });
            setAllAccountSelectedModal(isAllSelected);
            dispatch(setAllAccountOwned(isAllSelected));
        }
        if (!isAllSelected) {
            setFilteredProduct(newAry);
        }
    };
     const onIsSerialUnknown = (item, index, value, bundleIndex) => {
         let newArray =
             bundleIndex != 0
                 ? [...reportPaymentGridData][bundleIndex].bundleItem
                 : [...reportPaymentGridData];
        
         let islotSerialUnknownSelection = value;

         newArray[index] = {
             ...item,
             lotSerialNumber:
                 islotSerialUnknownSelection !== undefined
                     ? null
                     : item?.lotSerialNumber,
             lotSerialUnknown: islotSerialUnknownSelection,
             isInvalidLotSerialMsg:
                 islotSerialUnknownSelection !== undefined
                     ? null
                     : item?.isInvalidLotSerialMsg,
         };
          setReportPaymentGridData(newArray);
     };

    const deleteAll = () => {
        setFilteredProduct([]);
        resetSelectedOrAddedItem();
    };

    const editItem = (item, index, bundleIndex) => {
        const newAry = [...reportPaymentGridData];

        if (bundleIndex != undefined) {
            newAry[bundleIndex].bundleItem[index] = {
                ...item,
                isEditable: true,
            };
        } else {
            newAry[index] = {
                ...item,
                isEditable: true,
            };
        }

        setReportPaymentGridData(newAry);
    };

    const editChildItem = (item, childIndex) => {
        setSelectedChildEditItem(true);
        setSelectedChildItem(item);
        setSelectedChildIndex(childIndex);
    };

    const addSerialNumber = (item, index, bundleIndex) => {
        let newAry = [...filteredProduct];
        let newGridData = [...reportPaymentGridData];
        const newLotSerialEntry = { id: getUniqueKey() };
        
        if (bundleIndex != undefined) {
            newAry[bundleIndex].children[index].lotSerial.push(newLotSerialEntry);
            setFilteredProduct(newAry);
        } else {
            // Find the correct index in filteredProduct by matching unqId or cfn
            // since reportPaymentGridData index may not match filteredProduct index
            const targetIndex = newAry.findIndex(
                (fp) => (item.unqId && fp.unqId === item.unqId) || 
                        (item.cfn && fp.cfn === item.cfn && fp.productCFN === item.productCFN)
            );
            const actualIndex = targetIndex !== -1 ? targetIndex : index;
            
            // Initialize lotSerial array if it doesn't exist
            if (!newAry[actualIndex].lotSerial) {
                newAry[actualIndex].lotSerial = [];
            }
            newAry[actualIndex].lotSerial.push(newLotSerialEntry);
            setFilteredProduct(newAry);
            
            // Also update reportPaymentGridData directly for immediate UI update
            // Find the item in reportPaymentGridData by unqId or index
            const gridTargetIndex = newGridData.findIndex(
                (gd) => (item.unqId && gd.unqId === item.unqId) ||
                        (!item.unqId && gd.cfn === item.cfn && gd.productCFN === item.productCFN)
            );
            const gridActualIndex = gridTargetIndex !== -1 ? gridTargetIndex : index;
            
            if (!newGridData[gridActualIndex].lotSerial) {
                newGridData[gridActualIndex].lotSerial = [];
            }
            newGridData[gridActualIndex].lotSerial.push(newLotSerialEntry);
            setReportPaymentGridData(newGridData);
        }
    };

    useEffectWithErrorLogging(() => {
        if (
            addedChildProduct?.child &&
            Object.keys(addedChildProduct).length > 0
        ) {
            var newProduct = [...reportPaymentGridData];
            let filteredList = [];
            let filteredProductList = [];
            let selectedParentIndex = addedChildProduct.parent.index;
            let selectedParentItem = addedChildProduct.parent.cfn;

            filteredList = newProduct?.filter(
                (item) => item.cfn === selectedParentItem
            );
            
            if (filteredList) {
                const matchedParentItem = getArrayItem(filteredList);
                const existingChildItem = matchedParentItem?.children?.find(
                    (child) =>
                        child.cfn === addedChildProduct?.child &&
                        child?.lotSerialNumber ==
                            addedChildProduct?.lotFromScanner
                                ?.batchOrSerialNumber
                );

                const existingChildItemIndex =
                    matchedParentItem?.children?.findIndex(
                        (child) =>
                            child.cfn === addedChildProduct?.child &&
                            child?.lotSerialNumber ==
                                addedChildProduct?.lotFromScanner
                                    ?.batchOrSerialNumber
                    );

                if (existingChildItem && existingChildItemIndex !== -1) {
                    existingChildItem.usedQuantity =
                        (parseInt(existingChildItem.usedQuantity) || 0) + 1;

                    newProduct[selectedParentIndex].isBundleExpanded = true;
                    reportPaymentGridData[
                        selectedParentIndex
                    ].noItemInBundleErr = null;

                    newProduct[selectedParentIndex].noItemInBundleErr = null;
                    newProduct[selectedParentIndex].children[
                        existingChildItemIndex
                    ] = existingChildItem;
                    const reportPaymentChildIndex = reportPaymentGridData[
                        selectedParentIndex
                    ]?.bundleItem?.findIndex(
                        (child) =>
                            child.cfn === addedChildProduct?.child &&
                            child?.lotSerialNumber ==
                                addedChildProduct?.lotFromScanner
                                    ?.batchOrSerialNumber
                    );
                    if (reportPaymentChildIndex !== -1) {
                        reportPaymentGridData[selectedParentIndex].bundleItem[
                            reportPaymentChildIndex
                        ] = existingChildItem;
                    }
                    setReportPaymentGridData(reportPaymentGridData);
                    filteredProductList = newProduct.filter(
                        (item) => item !== undefined
                    );

                    const newArray = filteredProductList.map((item) => {
                        return {
                            ...item,
                            accountOwned: item.accountOwned
                                ? item.accountOwned
                                : false,
                        };
                    });
                    setFilteredProduct(newArray);
                } else {
                    const newlyAddedChildItem = {
                        quantity: addedChildProduct?.lotFromScanner ? '1' : '',
                        productCFN: addedChildProduct?.child,
                        isBundleChild: true,
                        dailyRate: '',
                        description: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner?.productDetails
                                  ?.description
                            : '',
                        salesOrg: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner?.productDetails
                                  ?.salesOrg
                            : '',
                        uom: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner?.productDetails
                                  ?.uom
                            : '',
                        lotSerialNumber: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner
                                  ?.batchOrSerialNumber
                            : '',
                        accountOwned: false,
                        usedQuantity: addedChildProduct?.lotFromScanner
                            ? '1'
                            : '',
                        isBundleFromAddItem: addedChildProduct.isBundle,
                        isSet: addedChildProduct.isSet,
                        isAdditionalCartChild: true,
                        cfn: addedChildProduct?.child,
                        id: generate_UUID(),
                        unqId: generate_UUID(),
                        isPriced: false,
                    };

                    if (addedChildProduct.isBundle) {
                        newlyAddedChildItem.isBundleItem = true;
                        newlyAddedChildItem.isInvalidItemMsg = t(
                            'productValidationMessages.bundleCannotBeAddedAsItemMsg'
                        );
                    }

                    if (!newProduct[selectedParentIndex]?.children)
                        newProduct[selectedParentIndex].children = [];

                    newProduct[selectedParentIndex].isBundleExpanded = true;
                    reportPaymentGridData[
                        selectedParentIndex
                    ].noItemInBundleErr = null;

                    newProduct[selectedParentIndex].noItemInBundleErr = null;
                    newProduct[selectedParentIndex].children.push(
                        newlyAddedChildItem
                    );
                    reportPaymentGridData[selectedParentIndex]?.bundleItem.push(
                        newlyAddedChildItem
                    );
                    setReportPaymentGridData(reportPaymentGridData);
                    filteredProductList = newProduct.filter(
                        (item) => item !== undefined
                    );

                    const newArray = filteredProductList.map((item) => {
                        return {
                            ...item,
                            accountOwned: item.accountOwned
                                ? item.accountOwned
                                : false,
                        };
                    });
                    setFilteredProduct(newArray);
                }
            }

            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
            setAddedChildProduct('');
            resetSelectedOrAddedItem();
            dispatch(resetBarcodeDetails());
        }
    }, [addedChildProduct]);

    const editedItemList = (e, item, idx, bundleIndex) => {
        const newAry =
            bundleIndex != undefined
                ? [...reportPaymentGridData][bundleIndex].bundleItem
                : [...reportPaymentGridData];

        const newValue = e.target.value.trim();

        if (
            newAry[idx].isInvalidItemMsg === invalidProductMsg() &&
            newAry[idx].cfn.toUpperCase() === newValue.toUpperCase()
        ) {
            return;
        } else {
            if (newAry[idx].cfn.toUpperCase() !== newValue.toUpperCase()) {
                if (
                    itemsToBePriced &&
                    itemsToBePriced.length > 0 &&
                    itemsToBePriced.includes(newAry[idx].cfn)
                ) {
                    let cfnArray = [newAry[idx].cfn];
                    newAry[idx].isBundleItem &&
                        newAry[idx].bundleItem?.map((bundle) =>
                            cfnArray.push(bundle.productCFN)
                        );

                    dispatch({
                        type: SET_ITEMS_DURING_PRICING,
                        payload: itemsToBePriced.filter(
                            (x) => !cfnArray.includes(x)
                        ),
                    });
                }
                newAry[idx] = getNewItemObj(
                    e.target,
                    newAry[idx],
                    false,
                    bundleHeadersArr,
                    bundleIndex >= 0,
                    myCaseResourceType
                );
            } else {
                newAry[idx] = {
                    ...item,
                    isInvalidItemMsg:
                        newAry[idx].isInvalidItemMsg === invalidProductMsg()
                            ? null
                            : newAry[idx].isInvalidItemMsg,
                    cfn: newValue,
                    productCFN: newValue,
                    isEditable: false,
                };
            }
            if (bundleIndex != undefined) {
                let temp = [...reportPaymentGridData];
                temp[bundleIndex].bundleItem = newAry;
                setReportPaymentGridData(temp);
            } else {
                setReportPaymentGridData(newAry);
                dispatch(setReportPaymentFlag(!reportPaymentFlag));
            }
        }
    };

    const editedChildItemList = (e, item, parentIndex) => {
        let newAry = [...filteredProduct];
        if (e.key === 'Enter' || e.keyCode === 13 || e.keyCode === 9) {
            newAry[parentIndex].children[selectedChildIndex] = {
                ...item,
                cfn: e.target.value,
            };
            setFilteredProduct(newAry);
            setSelectedChildEditItem(false);
        }
    };

    const lotSerialQtyInputChangeHandler = (
        e,
        item,
        index,
        i,
        indexes,
        checkedQty,
        bundleIndex
    ) => {

        var lotSerialValue = [];
        var newArray =
            bundleIndex != undefined
                ? [...reportPaymentGridData][bundleIndex].bundleItem
                : [...reportPaymentGridData];
        // Mobile renders a single lot/serial row and does NOT pass lotItemIdx, so
        // `indexes` arrives undefined. Default it to 0 so Used and Other merge onto
        // the SAME lotSerial entry — otherwise reading lotSerial[undefined] returns
        // undefined and entering the 2nd quantity wipes the 1st (only one side kept).
        if (indexes === undefined || indexes === null) {
            indexes = 0;
        }
        const previousObj = newArray[index].lotSerial[indexes];// this will give the id of specific lot serial obj
        let SerialValue = newArray[index];

        const isUnidBatchPresent = Object.prototype.hasOwnProperty.call(
            e,
            'batches'
        );

        if (
            item.isInvalidUnidItemQuantity &&
            isUnidBatchPresent &&
            previousObj.Serial !== e.batches
        ) {
            newArray[index].lotSerial[indexes].isInvalidQtyMsg =
                newArray[index].lotSerial[indexes].selectedBatchValue !==
                e.batches
                    ? null
                    : invalidUnidRodItemQtyMsg;
        }

        if (
            (item.salesOrg !== 'S030' ||
                item.salesOrg === '' ||
                !item.salesOrg) &&
            !displayCheckbox(item)
        ) {
            const isQuantityField =
                !isUnidBatchPresent &&
                (e.target.name?.toLowerCase() ===
                    t('reportUsage.itemList.used').toLowerCase() ||
                    e.target.name?.toLowerCase() ===
                        t('reportUsage.itemList.other').toLowerCase());

            let values = {};
            values = {
                ...previousObj,
                [isUnidBatchPresent
                    ? 'Serial'
                    : e.target.name.toLowerCase() ===
                      t('reportUsage.itemList.used').toLowerCase()
                    ? 'used'
                    : e.target.name.toLowerCase() ===
                      t('reportUsage.itemList.other').toLowerCase()
                    ? 'other'
                    : e.target.name]: isUnidBatchPresent
                    ? e.batches || ''
                    : isQuantityField
                    ? isNaN(parseInt(e.target.value))
                        ? ''
                        : parseInt(e.target.value)
                    : e.target.value?.trim(),
            };
            // Only update the appropriate quantity field based on input name
            const isUsedField = e.target.name?.toLowerCase() === t('reportUsage.itemList.used').toLowerCase();
            const isOtherField = e.target.name?.toLowerCase() === t('reportUsage.itemList.other').toLowerCase();
            if (isUsedField) {
                newArray[index].usedQuantity = e.target.value;
                newArray[index].lotSerial[indexes].usedQuantity = e.target.value;
            } else if (isOtherField) {
                newArray[index].otherQuantity = e.target.value;
                newArray[index].lotSerial[indexes].otherQuantity = e.target.value;
            }
            newArray[index].lotSerial.splice(indexes, 1, values);

            // For bundle children, also update the quantity field (used for validation)
            // Sum all 'used' values from lotSerial array
            if (bundleIndex != undefined && isQuantityField) {
                const totalUsedQty = newArray[index].lotSerial?.reduce((sum, lot) => {
                    const usedValue = isNaN(parseInt(lot.used)) ? 0 : parseInt(lot.used);
                    return sum + usedValue;
                }, 0) || 0;
                newArray[index].quantity = totalUsedQty;
                newArray[index].usedQuantity = totalUsedQty;
            }

            if (
                !isUnidBatchPresent &&
                isQuantityField &&
                values.isInvalidQtyMsg !==
                    t('reportUsage.itemTableErrorMessages.Bundle')
            ) {
                if (
                    !newArray[index].isInvalidItemMsg &&
                    e.target.value.length > 0 &&
                    (e.target.value === '0' || e.target.value === '00')
                ) {
                    values.isInvalidQtyMsg =
                        bundleIndex >= 0 || item.isBundleItem
                            ? t(
                                  'productValidationMessages.mustEnterUsedQuantity'
                              )
                            : t(
                                  'productValidationMessages.qtyRequired'
                              );
                } else if (
                    !newArray[index].isInvalidItemMsg &&
                    e.target.value.length > 0 &&
                    +e.target.value > 1 &&
                    item?.cfn?.startsWith('S33')
                ) {
                    values.isInvalidQtyMsg = t(
                        'productValidationMessages.feeQtyCanOnlyOne'
                    );
                } else if (
                    item.isInvalidUnidItemQuantity &&
                    item.batchQtyObjArr?.length > 0
                ) {
                    const batchQtyObj = item.batchQtyObjArr.filter(
                        (b) =>
                            b.batch === values.Serial && b.deliveredQty
                    );
                    const firstBatchQtyObj = getArrayItem(batchQtyObj);
                    if (firstBatchQtyObj) {
                        const unidDeliveredQty = firstBatchQtyObj.deliveredQty;
                        const usedQty =
                            isNaN(values.used) || !values.used
                                ? 0
                                : parseInt(values.used);
                        const otherQty =
                            isNaN(values.other) || !values.other
                                ? 0
                                : parseInt(values.other);
                        const totalUnidQty = usedQty + otherQty;

                        values.isInvalidQtyMsg =
                            totalUnidQty &&
                            unidDeliveredQty &&
                            totalUnidQty > parseInt(unidDeliveredQty)
                                ? invalidUnidRodItemQtyMsg
                                : null;
                    } else {
                        values.isInvalidQtyMsg = null;
                    }
                } else {
                    values.isInvalidQtyMsg = null;
                }
            }
        }

        if (
            !isUnidBatchPresent &&
            (item.salesOrg === 'S030' || displayCheckbox(item))
        ) {
            const newSerialValue = e.target?.value?.trim();
            // Clear error if serial number value has changed
            const shouldClearError = i?.Serial !== newSerialValue;
            
            // Check for duplicate serial across other items with same product CFN
            let duplicateError = null;
            if (newSerialValue?.length > 0 && !newArray[index].isLot && newArray[index].isSerialRequired) {
                const isDuplicate = newArray.some((otherItem, otherIdx) => 
                    otherIdx !== index && 
                    otherItem.productCFN === newArray[index].productCFN &&
                    (otherItem.lotSerialNumber === newSerialValue ||
                     otherItem.lotSerial?.some((ls) => ls.Serial === newSerialValue))
                );
                if (isDuplicate) duplicateError = productIssueErrMsg;
            }
            
            // Handle checkbox toggle (usedChecked/otherChecked)
            if (checkedQty === 'usedChecked') {
                newArray[index].lotSerial[indexes] = {
                    ...i,
                    used: !i.used,
                    isInvalidQtyMsg: !i.used === true ? null : false,
                    other: !i.used === true ? false : i.other,
                };
            } else if (checkedQty === 'otherChecked') {
                newArray[index].lotSerial[indexes] = {
                    ...i,
                    other: !i.other,
                    isInvalidQtyMsg: !i.other === true ? null : false,
                    used: !i.other === true ? false : i.used,
                };
            } else {
                // Handle serial number input change
                newArray[index].lotSerial[indexes] = {
                    ...i,
                    used: i.used !== undefined ? i.used : false,
                    isInvalidLotSerialMsg: duplicateError || (shouldClearError ? null : i?.isInvalidLotSerialMsg),
                    [e.target.name]: newSerialValue,
                    Serial: newSerialValue
                };
                // Also update item-level fields when serial number changes
                if (shouldClearError) {
                    newArray[index].isInvalidLotSerialMsg = duplicateError || null;
                    newArray[index].lotSerialNumber = newSerialValue;
                }
            }
        }

        if (
            !isUnidBatchPresent &&
            e.target.name === 'lotSerialNumber' &&
            (newArray[index].isLotSerialReqd ||
                newArray[index].isSerialRequired) &&
            !newArray[index].isInvalidItemMsg
        ) {
            if (e.target.value?.trim()?.length > 0) {
                const productsExceptFocused = newArray[index].lotSerial.filter(
                    (obj, i) =>
                        i !== indexes &&
                        obj.lotSerialNumber === newArray[index].lotSerial[indexes].lotSerialNumber
                );
                newArray[index].lotSerial[indexes].isInvalidLotSerialMsg =
                    !newArray[index].isLot &&
                    productsExceptFocused
                        .map((y) => y.lotSerialNumber)
                        .includes(e.target.value)
                        ? productIssueErrMsg
                        : false;
                if (
                    productsExceptFocused.every(
                        (z) => z.isInvalidLotSerialMsg === productIssueErrMsg
                    ) &&
                    newArray[index].lotSerial[indexes].isInvalidLotSerialMsg ===
                        productIssueErrMsg
                ) {
                    newArray[index].lotSerial[indexes].isInvalidLotSerialMsg = false;
                }
            } else {
                newArray[index].lotSerial[indexes].isInvalidLotSerialMsg =
                    newArray[index].isLot && !newArray[index]?.lotSerialUnknown
                        ? lotNumberReqdMsg()
                        : newArray[index]?.productCFN.startsWith('S33')
                        ? 'VendorCaseId field should not be Empty'
                        : !newArray[index]?.lotSerial?.[indexes] && serialNumberReqdMsg();
                newArray[index].lotSerial[indexes].linkedSstref =
                    newArray[index].lotSerial[indexes]?.linkedSstref?.length > 0
                        ? newArray[index]?.lotSerial[indexes]?.Serial?.length > 0
                            ? newArray[index].lotSerial[indexes]?.linkedSstref
                            : ''
                        : '';
            }
        }
        // Split rows (one qty-type each) display + price from the item-level
        // usedQuantity/otherQuantity. Mirror the edited lot/serial qty back to the
        // item level so the qty and extended price update immediately after edit.
        if (bundleIndex === undefined && newArray[index]?.isSplitLotSerialItem) {
            const splitLot = newArray[index].lotSerial?.[indexes];
            if (newArray[index].splitQtyType === 'used') {
                newArray[index].usedQuantity = splitLot?.used;
            } else if (newArray[index].splitQtyType === 'other') {
                newArray[index].otherQuantity = splitLot?.other;
            }
            // Keep the item-level qty validation flag in sync with the edited
            // lot/serial. Clicking Price Override with qty < 1 sets an item-level
            // isInvalidQtyMsg (getItemTableDataWithQtyValidation); without clearing
            // it here the Price Override / Next buttons stay disabled after the qty
            // is corrected (checkIfValidPricedRPItems reads the item-level flag).
            newArray[index].isInvalidQtyMsg = splitLot?.isInvalidQtyMsg || null;
        }
        if (bundleIndex != undefined) {
            let temp = [...reportPaymentGridData];
            temp[bundleIndex].bundleItem = newArray;
            setReportPaymentGridData(temp);
        } else {
            setReportPaymentGridData(newArray);
        }
    };

    return (
        <>
            {allAccountSelectedModal ? (
                <>
                    <WarningModal
                        id={'reportUsage-warning-modal-account-owned'}
                        message={t(
                            'reportUsage.record.reportPayment.ItemList.ItemListRPView.msg'
                        )}
                        onClose={() => setAllAccountSelectedModal(false)}
                        title={t('reportUsage.summary.accountOwned')}
                    />
                </>
            ) : null}
            {loaderOnOrientationChange ? (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner
                        id="reportUsage-itemListRPView-backdrop-loadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                    ></Spinner>
                </Backdrop>
            ) : (
                <>
                    {winWidth <= sizes.smalDevice ? (
                        <ItemsListRPContainerMobile
                            winWidth={winWidth}
                            filteredProduct={filteredProduct}
                            selectedChildEditItem={selectedChildEditItem}
                            selectedChildItem={selectedChildItem}
                            selectedChildIndex={selectedChildIndex}
                            onAccountOwnedSeleted={onAccountOwnedSeleted}
                            deleteAll={deleteAll}
                            deleteItem={deleteItem}
                            editItem={editItem}
                            editChildItem={editChildItem}
                            addSerialNumber={addSerialNumber}
                            editedItemList={editedItemList}
                            editedChildItemList={editedChildItemList}
                            lotSerialValueEntered={
                                lotSerialQtyInputChangeHandler
                            }
                            isBundleExpanded={isBundleExpanded}
                            setIsBundleExpanded={setIsBundleExpanded}
                            reportUsageFormObj={reportUsageFormObj}
                            setReportUsageFormObj={setReportUsageFormObj}
                            usageDetails={usageDetails}
                            isFromReportScreen={isFromReportScreen}
                            checkNewAddedProduct={checkNewAddedProduct}
                            checkboxReportPaymentClickHandler={
                                checkboxReportPaymentClickHandler
                            }
                            reportPaymentGridData={reportPaymentGridData}
                            setReportPaymentGridData={setReportPaymentGridData}
                            selectedCheckBox={selectedCheckBox}
                            checkBoxSelectedIndex={checkBoxSelectedIndex}
                            deletePO={deletePO}
                            onImagePreview={onImagePreview}
                            myCaseResourceType={myCaseResourceType}
                            onIsSerialUnknown={onIsSerialUnknown}
                            {...props}
                        />
                    ) : (
                        <ItemsListRPContainerDesktop
                            winWidth={winWidth}
                            filteredProduct={filteredProduct}
                            selectedChildEditItem={selectedChildEditItem}
                            selectedChildItem={selectedChildItem}
                            selectedChildIndex={selectedChildIndex}
                            onAccountOwnedSeleted={onAccountOwnedSeleted}
                            deleteAll={deleteAll}
                            deleteItem={deleteItem}
                            editItem={editItem}
                            editChildItem={editChildItem}
                            addSerialNumber={addSerialNumber}
                            editedItemList={editedItemList}
                            editedChildItemList={editedChildItemList}
                            lotSerialValueEntered={
                                lotSerialQtyInputChangeHandler
                            }
                            isBundleExpanded={isBundleExpanded}
                            setIsBundleExpanded={setIsBundleExpanded}
                            reportUsageFormObj={reportUsageFormObj}
                            setReportUsageFormObj={setReportUsageFormObj}
                            usageDetails={usageDetails}
                            isFromReportScreen={isFromReportScreen}
                            checkNewAddedProduct={checkNewAddedProduct}
                            checkboxReportPaymentClickHandler={
                                checkboxReportPaymentClickHandler
                            }
                            reportPaymentGridData={reportPaymentGridData}
                            setReportPaymentGridData={setReportPaymentGridData}
                            selectedCheckBox={selectedCheckBox}
                            checkBoxSelectedIndex={checkBoxSelectedIndex}
                            deletePO={deletePO}
                            onImagePreview={onImagePreview}
                            myCaseResourceType={myCaseResourceType}
                            showBundlefromTableList={showBundlefromTableList}
                            resetSelectedOrAddedItem={resetSelectedOrAddedItem}
                            onIsSerialUnknown={onIsSerialUnknown}
                            {...props}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default ItemListRPView;
